const SYS_ADMIN = "SYS_ADMIN";
const SYS_SUPERVISOR = "SYS_SUPERVISOR";
const SYS_BO = "SYS_BO";
const ADMIN = "ADMIN";
const USER = "USER";
const API = "API";
const SECURITY = "SECURITY";

const state = {
  roles: {
    SYS_ADMIN,
    SYS_SUPERVISOR,
    SYS_BO,
    ADMIN,
    USER,
    SECURITY,
    API,
    COMPANY_SUPERVISOR_ROLES: [ADMIN, USER],
    ALL_SYS_ROLES: [SYS_ADMIN, SYS_SUPERVISOR, SYS_BO],
    ONLY_ADMINS: [SYS_ADMIN, ADMIN]
  },
  OBLIGATIONS: {
    STATUS: {
      DELIVERED: "delivered",
      NOT_DELIVERED: "not_delivered",
      DELAYED: "delayed",
      MISSING_DATE: "missing_date",
      APPROVAL_PENDING: "approval_pending",
      APPROVAL_CANCELLED: "cancelled",
      EXCLUDED: "excluded"
    },
    DUEDATE_TYPES: {
      MONTHLY: "monthly",
      BIMONTHLY: "bimonthly",
      QUARTERLY: "quarterly",
      BIANNUAL: "biannual",
      ANNUAL: "annual",
      ONCE: "once",
      DATE_LIMIT: "date_limit"
    },
    TYPES: {
      VEHICLE_OBLIGATION: "vehicle_obligation",
      OBLIGATION: "contractor_obligation",
      EMPLOYEES_OBLIGATION: "employee_obligation"
    }
  },
  IDENTIFIERS: {
    DNI: "dni",
    CUIT: "cuit",
    CUIL: "cuil"
  },
  DATE_FORMAT: "DD/MM/YYYY",
  PROVINCES: [
    { name: "Buenos Aires" },
    { name: "Ciudad Autónoma de Buenos Aires" },
    { name: "Catamarca" },
    { name: "Chaco" },
    { name: "Chubut" },
    { name: "Córdoba" },
    { name: "Corrientes" },
    { name: "Entre Ríos" },
    { name: "Formosa" },
    { name: "Jujuy" },
    { name: "La Pampa" },
    { name: "La Rioja" },
    { name: "Mendoza" },
    { name: "Neuquén" },
    { name: "Río Negro" },
    { name: "Salta" },
    { name: "San Juan" },
    { name: "San Luis" },
    { name: "Santa Fé" },
    { name: "Santiago Del Estero" },
    { name: "Tierra Del Fuego" },
    { name: "Tucumán" }
  ],
  VISIT: {
    authorized: "authorized",
    pending_authorization: "pending_authorization",
    active: "active",
    rejected: "rejected",
    finished: "finished",
    cancelled: "cancelled",
    pending_rate: "pending_rate",
    rated: "rated"
  },
};

export default { state };
